import { render, staticRenderFns } from "./InitiativeCustomizationDetail.vue?vue&type=template&id=3af159b3"
import script from "./InitiativeCustomizationDetail.vue?vue&type=script&lang=ts"
export * from "./InitiativeCustomizationDetail.vue?vue&type=script&lang=ts"
import style0 from "./InitiativeCustomizationDetail.vue?vue&type=style&index=0&id=3af159b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports